import React, { Component } from "react";
import { connect } from "react-redux";
import ModalWrapper, { withOnClose } from "../ModalWrapper";
import './styles.scss';
import store from "../../../store";
import ContentDataV1Task from "../../../requests/tasks/content/ContentDataV1Task";
import RequestManager from "../../../requests/RequestManager";
import LikesServiceTask from "../../../requests/tasks/likes/LikesServiceTask";
import Utils, { secondsToMiliseconds } from "../../../utils/Utils";
import Translator from "../../../requests/apa/Translator";
import { configButtons, ratingValues, configNotifications, typeButtons, EVENT_ERROR, INTERACTION_PLAYER } from "./constants";
import RatingAssetButton from "./RatingAssetButton";
import { HIDE_MODAL, MODAL_RATING_CONTENT } from "../../../actions/modal";
import { HIDE_NOTIFICATION, SHOW_NOTIFICATION } from "../../../actions/notification";
import { TOAST_NOTIFICATION } from "../../../containers/Notification";
import Asset from "../../../requests/apa/Asset";
import Device from "../../../devices/device";
import { sendMetricsRating } from "./utils";
import { createPipVideo, resetStylesToFullScreen, getVideoElements } from "../../Video/pip/utils/utilsPipVideo";
import { Button } from "../../../packages/components";

class RatingContent extends Component {

    constructor(props){
        super(props);

        // Tiempos de visualización del modal de calificación de contenido
        const {display_time, max_display_time, post_vote_display_time} = Utils.getRegionaliazedMetadata('vod_rating_settings','{"default": {"enable": true,"display_time": 30,"max_display_time": 60,"post_vote_display_time": 10}}');
        this.max_display_time = max_display_time;
        this.post_vote_display_time = post_vote_display_time;
        this.state = {
            backgroundImage: null,
            title: null,
            loading: true,
            selectedRating: null,
            display_time: display_time,
            showDecrementTimer: true,
        };

        this.mediaData = props.pgm.group.common;
        this.isSerie = props.isSerie;

        this.decrementTimer = null;
        //Bandera para evitar setState en componentes desmontados
        this._isMounted = false;
        //Bandera para evitar envíos múltiples de votos
        this.isSubmittingVote = false;
        //referencia del timer que revisa si el player está visible
        this.checkPlayerVisibilityInterval = null;

        this.groupId = this.getCurrentGroupId();

        this.keys = Device.getDevice().getKeys()
    }

    safeSetState = (nextState, callback) => {
        if (!this._isMounted) {
            return;
        }

        this.setState(nextState, callback);
    }

    buildRatingMetrics = (ratingType) => ({
        interaction_type: Translator.get(configNotifications[typeButtons[ratingType]].title.Key),
        rating_message: Translator.get(configNotifications[typeButtons[ratingType]].message.Key),
        modulo_name: 'panel de calificacion de contenido',
        ...getMediaDataMetrics(this.mediaData, this.isSerie)
    })

    getCurrentGroupId = () => {
        const playerState = store.getState().player;
        return playerState.source && playerState.source.videoid;
    }

    handleSelectRating = async (ratingType) => {
        const currentLikeValue = this.state.selectedRating;

        if (!this.groupId || this.isSubmittingVote) {
            return;
        }

        this.isSubmittingVote = true;

        try {
            if (currentLikeValue === ratingType) {
                const deleteLikesServiceTask = new LikesServiceTask({
                    method: 'DELETE',
                    group_id: this.groupId,
                    group_uid: null
                });

                await RequestManager.addRequest(deleteLikesServiceTask);
                this.hideNotification()
                this.updateStateAfterVote(null)
            } else{
                const postLikesServiceTask = new LikesServiceTask({
                    method: 'POST',
                    like: ratingValues[ratingType],
                    stars: 0,
                    group_id: this.groupId,
                    group_uid: null
                });

                await RequestManager.addRequest(postLikesServiceTask);
                this.showNotification(ratingType)
                this.updateStateAfterVote(ratingType)
            }
            const dataMetrics = this.buildRatingMetrics(ratingType);
            sendMetricsRating(INTERACTION_PLAYER, dataMetrics);
        } catch (error) {
            const errorMetrics = {
                ...this.buildRatingMetrics(ratingType),
                error_title: 'rating error',
                error_message: error && error.message ? error.message : '',
                error_type: error && error.type ? error.type : '',
                error_code: error && error.code ? error.code : '',
            };
            sendMetricsRating(EVENT_ERROR, errorMetrics);
            this.showNotification(typeButtons.error)
            this.hideModal()
        } finally {
            this.isSubmittingVote = false;
        }
    }

    updateStateAfterVote = (ratingType) => {
        this.safeSetState({ 
            selectedRating: ratingType,
            showDecrementTimer: false,
            display_time: this.post_vote_display_time
        })
    }

    showNotification = (typeButton) => {
        store.dispatch({
            type: SHOW_NOTIFICATION,
            notificationProps: {
                typeNotification: TOAST_NOTIFICATION,
                title: Utils.cutPlayerString(Translator.get(configNotifications[typeButton].title.Key), configNotifications[typeButton].title.length),
                text: Utils.cutPlayerString(Translator.get(configNotifications[typeButton].message.Key), configNotifications[typeButton].message.length),
                img: Asset.get(configNotifications[typeButton].icon.Key),
                imgStyles: configNotifications[typeButton].icon.styles || {},
                displayDurationSeconds: 6,
            }
        })
    }

    hideNotification = () => {
        store.dispatch({
            type: HIDE_NOTIFICATION
        })
    }

    async componentDidMount(){
        this._isMounted = true;
        this.createMaximumDisplayTimer();
        const loaded = await this.getData();

        if (loaded) {
            this.createDecrementTimer();
        }
    }

    componentWillUnmount(){
        this._isMounted = false;
        this.isSubmittingVote = false;
        this.cleanupResources();
    }

    cleanupResources = () => {
        this.deleteDecrementTimer();
        this.deleteMaximumDisplayTimer();
    }

    createMaximumDisplayTimer = () => {
        this.maxDisplayTimer = setTimeout(() => {
            this.hideModal();
        }, secondsToMiliseconds(this.max_display_time));
    }

    deleteMaximumDisplayTimer = () => {
        if(this.maxDisplayTimer) {
            clearTimeout(this.maxDisplayTimer);
            this.maxDisplayTimer = null;
        }
    }

    createDecrementTimer = () => {
        this.deleteDecrementTimer();
        this.decrementTimer = setInterval(() => {
            this.safeSetState(prevState => {
                if (prevState.display_time <= 1) {
                    clearInterval(this.decrementTimer);
                    this.decrementTimer = null;
                    this.hideModal();
                    return { display_time: 0 };
                }
                return { display_time: prevState.display_time - 1 };
            });
        }, 1000);
    }

    deleteDecrementTimer = () => {
        if(this.decrementTimer) {
            clearInterval(this.decrementTimer);
            this.decrementTimer = null;
        }
    }

    getData = async () => {
        if(!this.groupId) {
            this.hideModal();
            return false;
        }

        try{
            const contentDataV1Task = new ContentDataV1Task(this.groupId);
            const {response} = await RequestManager.addRequest(contentDataV1Task)
            const { group: { common } = {} } = response || {};
            const title = common && common.title;
            const backgroundImage = common && (common.image_clean_horizontal || common.image_background);
            this.safeSetState({
                backgroundImage,
                title,
                loading: false
                }, () => {
                this.createPipVideo();
                this.togglePlayerControls(false);
                if (window.SpatialNavigation && document.querySelector('.btn-close')) {
                    window.SpatialNavigation.focus('.btn-close');
                }
            }) 
            return true;
        } catch(e){
            this.hideModal()
            return false;
        }
    }

    createPipVideo = () => {
        const {videoPlayerMain} = getVideoElements()
        if(videoPlayerMain) videoPlayerMain.style.borderRadius = '1.06rem';
        createPipVideo('#pip-rating');
    }

    hideModal = () => {
        this.cleanupResources();
        store.dispatch({type: HIDE_MODAL, modalType: MODAL_RATING_CONTENT})
        resetStylesToFullScreen()
        this.togglePlayerControls(true);
    }

    cancelNavigation = (e) => {
        const kepress = this.keys.getPressKey(e.keyCode);
        if (kepress !== 'RIGHT' && kepress !== 'LEFT') return;
        e.preventDefault();
        e.stopPropagation()
    }

    togglePlayerControls = (visible) => {
        if (!document) return;
        
        const playerControls = document.getElementById('n_player_controls');
        const playerControlsFather = playerControls ? playerControls.parentElement : null;
        if (playerControlsFather) {
            playerControlsFather.style.display = visible ? 'unset' : 'none';
        }
    }

    


    render() {
        const {backgroundImage, title, loading, selectedRating, display_time, showDecrementTimer} = this.state;
        const {groupId} = this.props;

        if(loading) return null

        return(
            <ModalWrapper callbackWhenBack={this.hideModal}  classNameComponent='rating-content-modal-container rating-content' className='full-screen' childrenClassName='full-screen'>
                <div className="full-screen background-container" style={{backgroundImage: `url(${backgroundImage})`}}>
                    <div className="full-screen principal-container" style={{background: 'rgba(18, 18, 18, 0.65)'}}>
                        <div className="player-container">
                            { groupId 
                                && <Button className="focusable btn-pip" onClick={this.hideModal} onKeyDown={this.cancelNavigation}>
                                        <div id="pip-rating"></div>
                                    </Button> 
                            } 
                        </div>                   
                        <div className="timer">
                            {
                                showDecrementTimer && 
                                <p>
                                    {`${Utils.cutPlayerString(Translator.get('CalificadorContenidos_Texto_Contador1'), 11)} ${display_time} ${Utils.cutPlayerString(Translator.get('CalificadorContenidos_Texto_Contador2'), 14)} `}
                                </p>
                            }
                        </div>
                        <div className="content-container">
                            <div className="content-info-container">
                                 <p className="title no-margin fw-700">
                                    {Utils.cutPlayerString(title, 35)}
                                </p>
                            </div>

                            <div className="content-info-container">
                                <p className="subtitle no-margin">
                                    <span className="fw-700">{Utils.cutPlayerString(Translator.get('CalificadorContenidos_Texto_Subtitulo1'), 10)} </span>
                                    <span>{Utils.cutPlayerString(Translator.get('CalificadorContenidos_Texto_Subtitulo2'), 58)}</span>
                                </p>

                                <div className="buttons-container">

                                        <RatingAssetButton
                                            className="btn btn-rating btn-like focusable"
                                            buttonConfig={configButtons.like}
                                            textClassName="no-margin fw-700"
                                            isClicked={selectedRating === typeButtons.like}
                                            onClick={() => this.handleSelectRating(typeButtons.like)}
                                        />

                                        <RatingAssetButton
                                            className="btn btn-rating focusable"
                                            buttonConfig={configButtons.loveit}
                                            textClassName="no-margin fw-700"
                                            enableClickedState
                                            isClicked={selectedRating === typeButtons.loveit}
                                            onClick={() => this.handleSelectRating(typeButtons.loveit)}
                                        />

                                        <RatingAssetButton
                                            className="btn btn-rating focusable"
                                            buttonConfig={configButtons.dislike}
                                            textClassName="no-margin fw-700"
                                            enableClickedState
                                            isClicked={selectedRating === typeButtons.dislike}
                                            onClick={() => this.handleSelectRating(typeButtons.dislike)}
                                        />

                                </div>
                            </div>
                        </div>
                        <div className="close-btn-container">
                            <RatingAssetButton
                                className="btn btn-close focusable"
                                buttonConfig={configButtons.close}
                                textClassName="no-margin"
                                onClick={this.hideModal}
                                onKeyDown={this.cancelNavigation}
                            />
                        </div>
                    </div>
                </div>
            </ModalWrapper>
        )
    }
}

const mapStateToProps = (state) => ({
    groupId: state.player.source && state.player.source.videoid
});

export default connect(mapStateToProps)(withOnClose(RatingContent));


// WEBPACK FOOTER //
// ./src/components/Modal/ratingContent/RatingContent.jsx